import { ICatalogue } from "../../apis/useGetCatalogueData/types";

export const duplicateCart = (cart: ICatalogue[]): ICatalogue[] =>
	[...cart].map((item) => ({ ...item }));
